import { useQuery } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useFetchClientByOwner(id_owner?: string) {
  const token = useAccessToken()
  return useQuery({
    queryKey: ['client', id_owner],
    queryFn: async () => {
      if (!id_owner) throw new Error('CNPJ ou CPF não fornecido')

      const response = await api.get(`/clients/owner/${id_owner}`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data && response.data.data) {
        return response.data.data
      } else {
        throw new Error('Data não encontrado no resultado')
      }
    },
    enabled: Boolean(id_owner)
  })
}
